import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    UpdateImportExportWizardVisibility,
    updateImportExportWizardVisibilityAction
} from '../../actions/importExportWizard/updateImportExportWizardVisibility';
import {
    SAVE_IMPORT_WIZARD_SUCCESS,
    SaveImportWizardSuccess
} from '../../actions/importWizard/saveImportWizardSuccess';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

type EpicActions = UpdateImportExportWizardVisibility;

export const saveImportWizardSuccessEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(SAVE_IMPORT_WIZARD_SUCCESS),
        switchMap(
            (action: SaveImportWizardSuccess): Observable<EpicActions> => {
                return of(updateImportExportWizardVisibilityAction(false));
            }
        )
    );
};
